import { CSSProperties } from 'react';

const DEFAULT_IDENTITY_MIN_WIDTH_REM = 24;
const DEFAULT_COLUMN_MIN_WIDTH_REM = 11;
const DEFAULT_COLUMN_GAP_REM = 1;
const DEFAULT_ACTION_COLUMN_WIDTH_REM = 2.5;
const DEFAULT_MIN_WIDTH_BUFFER_REM = 0.5;

export interface ColumnarListGridOptions {
    actionColumnWidthRem?: number;
    columnCount: number;
    columnGapRem?: number;
    columnMinWidthRem?: number;
    identityMinWidthRem?: number;
    minWidthBufferRem?: number;
}

const resolveOptions = ({
    actionColumnWidthRem = DEFAULT_ACTION_COLUMN_WIDTH_REM,
    columnCount,
    columnGapRem = DEFAULT_COLUMN_GAP_REM,
    columnMinWidthRem = DEFAULT_COLUMN_MIN_WIDTH_REM,
    identityMinWidthRem = DEFAULT_IDENTITY_MIN_WIDTH_REM,
    minWidthBufferRem = DEFAULT_MIN_WIDTH_BUFFER_REM,
}: ColumnarListGridOptions) => ({
    actionColumnWidthRem,
    columnCount,
    columnGapRem,
    columnMinWidthRem,
    identityMinWidthRem,
    minWidthBufferRem,
});

export const getColumnarListGridTemplate = (options: ColumnarListGridOptions): string => {
    const { actionColumnWidthRem, columnCount, columnMinWidthRem, identityMinWidthRem } = resolveOptions(options);

    return `minmax(${identityMinWidthRem}rem, 2fr) repeat(${columnCount}, minmax(${columnMinWidthRem}rem, 1fr)) ${actionColumnWidthRem}rem`;
};

export const getColumnarListGridMinWidth = (options: ColumnarListGridOptions): string => {
    const { actionColumnWidthRem, columnCount, columnMinWidthRem, identityMinWidthRem, minWidthBufferRem } =
        resolveOptions(options);

    return `${identityMinWidthRem + columnCount * columnMinWidthRem + actionColumnWidthRem + minWidthBufferRem}rem`;
};

export const getColumnarListGridStyle = (options: ColumnarListGridOptions): CSSProperties => {
    const { columnGapRem } = resolveOptions(options);

    return {
        alignItems: 'center',
        columnGap: `${columnGapRem}rem`,
        display: 'grid',
        flex: 1,
        gridTemplateColumns: getColumnarListGridTemplate(options),
        minWidth: getColumnarListGridMinWidth(options),
        width: '100%',
    };
};

export const columnarListGridCellStyle: CSSProperties = {
    minWidth: 0,
};
